<template lang="pug">
div
  .mobile-thm
    .tmimg-1
      img(:src="'/assets/img/themeui/mobile/' + imageURL + '.jpg?v1'")
    .themeframe-img
      img(src='/assets/img/newwebsite/mobile-frame.png')
  .tablet-thm
    .tmimg-2
      img(:src="'/assets/img/themeui/desktop/' + imageURL + '.jpg?v1'")
    .themeframe-img
      img(src='/assets/img/newwebsite/tablet-frame.png')
</template>
<script>

export default {
  props: {
    imageURL: {
      type: String,
      default: null
    }
  },
}
</script>